import React, { useState, useEffect } from 'react';
import { Container, CardBody, Card, Badge } from 'reactstrap';
import IntlMessage from '../../../helpers/intlMessage';
import { DataTable, Column } from 'vivace-fluent-motion';

function Table (props) {
  const [listaFormatada, setListaFormatada] = useState([]);

  useEffect(() => {
    const listaAlterada = props.lista.map(x => ({
       ...x,
       remover: (
        <div>
          <Badge
            id={x.laudoid}
            pill='info'
            className="badge badge-info"
            onClick={(e) => {props.removerDaLista(e)}}
          >
            <IntlMessage id="general.materialArchiving.remove"/>
          </Badge>
        </div>
       )
    }));

    setListaFormatada(listaAlterada);
  }, [props.lista]);

  return (
    <Card style={{marginTop: '15px'}}>
      <CardBody>
        <Container fluid>
          <DataTable
            value={listaFormatada}
            responsive={true}
            selectionMode='single'
            style={{height: '50vh'}}
            columnResizeMode='expand'
            scrollable={true}
            scrollHeight='50vh'
            scrollWidth='100%'
            resizableColumns={listaFormatada.length >= 0}
            reorderableColumns={listaFormatada.length >= 0}
            lazy={true}
            //emptyMessage={<IntlMessage id="general.materialArchiving.noResultsFound" />}
            alwaysShowPaginator={false}
            autoLayout={true}
            dataKey="laudoid"
          >
            <Column field='nrpedido' header={<IntlMessage id="dashboards.doctorTasks.orderNumber"/>} style={{width: '75px'}}/>
            <Column field='nrexame' header={<IntlMessage id="dashboards.cytology.numberExam"/>} style={{width: '85px'}}/>
            <Column field='exame' header={<IntlMessage id="general.materialArchiving.exam"/>} style={{width: '180px'}}/>
            <Column field='paciente' header={<IntlMessage id="general.materialArchiving.patient"/>} style={{width: '180px'}}/>
            <Column field='dataconclusao' header={<IntlMessage id="dashboards.examDetails.conclusion"/>} style={{width: '85px'}}/>
            <Column field='remover' style={{width: '50px'}}/>
          </DataTable>
        </Container>
      </CardBody>
    </Card>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/pages/tarefas/Table/index.js